export interface FeatureFlags {
  dispatchBoard: boolean;
  unifiedWorkspaceShell: boolean;
  eprfV2: boolean;
  offlineQueueV2: boolean;
  tenantAdmin: boolean;
}

const envFlag = (value: string | undefined, fallback: boolean): boolean => {
  if (!value) return fallback;
  return value.toLowerCase() === 'true';
};

export const featureFlags: FeatureFlags = {
  dispatchBoard: envFlag(import.meta.env.VITE_FF_DISPATCH_BOARD, true),
  unifiedWorkspaceShell: envFlag(import.meta.env.VITE_FF_UNIFIED_WORKSPACE, false),
  eprfV2: envFlag(import.meta.env.VITE_FF_EPRF_V2, false),
  offlineQueueV2: envFlag(import.meta.env.VITE_FF_OFFLINE_QUEUE_V2, false),
  tenantAdmin: envFlag(import.meta.env.VITE_FF_TENANT_ADMIN, false),
};
